import { createSelector } from 'reselect';

const selectSectionTemplates = (state: any) => state.sectionTemplates;


export const selectSectionTemplatesCurrentItem = createSelector([selectSectionTemplates], (sectionTemplates) => sectionTemplates.current);

export const selectSectionTemplatesListItems = createSelector([selectSectionTemplates], (sectionTemplates) => sectionTemplates.list);

export const selectSectionTemplatesItemById = (itemId: any) =>
    createSelector(selectSectionTemplatesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectSectionTemplatesQueryItems = createSelector([selectSectionTemplates], (sectionTemplates) => sectionTemplates.query);

export const selectSectionTemplatesCreatedItem = createSelector([selectSectionTemplates], (sectionTemplates) => sectionTemplates.create);

export const selectSectionTemplatesUpdatedItem = createSelector([selectSectionTemplates], (sectionTemplates) => sectionTemplates.update);

export const selectSectionTemplatesReadItem = createSelector([selectSectionTemplates], (sectionTemplates) => sectionTemplates.read);

export const selectSectionTemplatesDeletedItem = createSelector([selectSectionTemplates], (sectionTemplates) => sectionTemplates.delete);

export const selectSectionTemplatesSearchedItems = createSelector([selectSectionTemplates], (sectionTemplates) => sectionTemplates.search);

export const selectSectionTemplatesItemsCount = createSelector([selectSectionTemplates], (sectionTemplates) => sectionTemplates.count);

export const selectSectionTemplatesItemsFilter = createSelector([selectSectionTemplates], (sectionTemplates) => sectionTemplates.filter);